export default __webpack_public_path__ + "static/media/social.0cdb8bdf.svg";